module.exports = __webpack_public_path__ + "static/6-Cerca de la Puerta-909f39437f44bce7e0bdab2ac9f80e76.jpg";